export default {
  planilhas: {
    processo: {
      colunas: [],
      colunasExportar: [],
    },
    cambio: {
      colunas: [],
      colunasExportar: [],
    },
    estoque: {
      colunas: [],
      colunasExportar: [],
    },
  },
};
